import httpManager from "@/app/shared/utils/httpManager";
/**
 * Obtener descarga realizas por el usuario
 * @return {Promise<Object>} descarga.
 */
export async function fetchDownload({ proccessId }: { proccessId: string | number | undefined }) {
  const response = await httpManager.getBlob(`processes/${proccessId}/download/`);
  return response;
}
